import { TranslateResult } from 'vue-i18n';

export interface BudgetModeOptionItem {
  label: TranslateResult;
  value: string;
  hide: boolean;
}

export interface BudgetRecommendOptionItem {
  title: TranslateResult;
  budget: number;
  impression: number;
}

/** 设置 budget 的类型 */
export enum BudgetSourceType {
  /** 点击文案中的 apply */
  apply = 1,
  /* 点击展开中的 apply */
  detailApply = 2,
  /** 手动填写 */
  manual = 3
}

export interface BudgetRecommendResponse {
  enoughBudget: number;
  enoughImpression: number;
  competitiveBudgetAvailable: boolean;
  competitiveBudget: number;
  competitiveImpression: number;
}
